export class CNPJUtils {
    static invalidCNPJs: string[] = [
        "00000000000000",
        "11111111111111",
        "22222222222222",
        "33333333333333",
        "44444444444444",
        "55555555555555",
        "66666666666666",
        "77777777777777",
        "88888888888888",
        "99999999999999"
    ];

    public static ValidarCNPJ(cnpj: string): boolean {
        if (!cnpj) return false;

        cnpj = cnpj.trim();
        cnpj = cnpj.split(".").join("").split("-").join("").split("/").join("");

        if (cnpj.length != 14) return false;

        // Check if last two characters are numeric
        if (!/^\d{2}$/.test(cnpj.substring(12))) {
            return false;
        }

        // Check for blacklisted numeric CNPJs
        if (/^\d+$/.test(cnpj) && CNPJUtils.invalidCNPJs.includes(cnpj)) {
            return false;
        }

        const multiplicador1: number[] = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        const multiplicador2: number[] = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        // Helper to get value of char (ASCII - 48)
        const getCharCode = (c: string): number => {
            return c.charCodeAt(0) - 48;
        };

        const tempCnpj = cnpj.substring(0, 12);
        let soma = 0;

        for (let i = 0; i < 12; i++) {
            soma += getCharCode(tempCnpj[i].toUpperCase()) * multiplicador1[i];
        }

        let resto = soma % 11;

        if (resto < 2) resto = 0;
        else resto = 11 - resto;

        const digito1 = resto.toString();
        const tempCnpjWithDigit1 = tempCnpj + digito1;
        soma = 0;

        for (let i = 0; i < 13; i++) {
            soma += getCharCode(tempCnpjWithDigit1[i].toUpperCase()) * multiplicador2[i];
        }

        resto = soma % 11;

        if (resto < 2) resto = 0;
        else resto = 11 - resto;

        const digito2 = resto.toString();

        return cnpj.endsWith(digito1 + digito2);
    }
}

